import { FC } from 'react';

import { AddressFinderAvailabilityStep } from '@eneco/flows/components';
import { usePlaceholderContent } from '@sitecore/common';
import { SolarBoilerLeadFlowAddressStepRendering } from '@sitecore/types/SolarBoilerLeadFlowAddressStep';

import { ProductType, OrderType } from '../../types/types';

export const AddressStep: FC = () => {
  const { SolarBoilerLeadFlowAddressStep: { fields: textualData } = {} } = usePlaceholderContent<{
    SolarBoilerLeadFlowAddressStep: SolarBoilerLeadFlowAddressStepRendering;
  }>();

  return (
    <AddressFinderAvailabilityStep
      product={ProductType.EBoiler}
      orderType={OrderType.Installation}
      textualData={textualData}
      trackUnavailableNotification
    />
  );
};
